import { Button, Tooltip } from '@chakra-ui/react'
import { environments } from 'environments/environments'
import { useCacheFilters } from 'hooks/useCacheFilters'
import { useRef, useState } from 'react'
import {
    ModalCancelContract,
    ModalCancelContractHandle
} from '../ModalCancelContract'

interface CancelOrRemoveActionProps {
    contractId: string
    contractStatus: string
    setDisableAllButton: (disable: boolean) => void
    disableAllButton: boolean,
}

interface ButtonOption {
    label: string
    contractOperation: number
}

export const CancelOrRemoveAction: React.FC<CancelOrRemoveActionProps> = ({
    contractId,
    contractStatus,
    setDisableAllButton,
    disableAllButton,
}) => {
    if (['CANCELADO', 'BAIXADO'].includes(contractStatus)) return <></>

    const { CONTRACT_CANCELLATION } = environments
    const [operationContract, setOperationContract] = useState<number>(0)
    const refCancelModal = useRef<ModalCancelContractHandle>(null)

    const optionsBtns: ButtonOption[] = [
        {
            label: 'Cancelar Contrato',
            contractOperation: 1
        },
        {
            label: 'Baixar Contrato',
            contractOperation: 2
        }
    ]

    const { getCacheFilters } = useCacheFilters()
    const institutionInactive = !getCacheFilters()?.currentInstitution.ativa

    return (
        <>
            <ModalCancelContract
                setDisableAllButton={setDisableAllButton}
                ref={refCancelModal}
                contractId={contractId}
                operationContract={operationContract}
            />

            {CONTRACT_CANCELLATION && (
                <>
                    {optionsBtns.map(btn => (
                        <Tooltip
                            key={btn.contractOperation}
                            label="Esta Instituição Financeira está temporariamente inativa, portanto, a operação não pode ser realizada. Para mais informações, entre em contato com o suporte."
                            placement="top"
                            isDisabled={!institutionInactive}
                        >
                            <Button
                                colorScheme="primary"
                                marginLeft="auto"
                                onClick={() => {
                                    setOperationContract(btn.contractOperation)
                                    refCancelModal.current?.openModal()
                                }}
                                isDisabled={
                                    institutionInactive || disableAllButton
                                }
                            >
                                {btn.label}
                            </Button>
                        </Tooltip>
                    ))}
                </>
            )}
        </>
    )
}
